import { render, staticRenderFns } from "./ExpandingPanel.vue?vue&type=template&id=977ea49a&"
import script from "./ExpandingPanel.vue?vue&type=script&lang=ts&"
export * from "./ExpandingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandingPanel.vue?vue&type=style&index=0&id=977ea49a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports